import { render, staticRenderFns } from "./CardStart.vue?vue&type=template&id=8dfb18d2&"
import script from "./CardStart.vue?vue&type=script&lang=js&"
export * from "./CardStart.vue?vue&type=script&lang=js&"
import style0 from "./CardStart.vue?vue&type=style&index=0&id=8dfb18d2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports